import { QuestionFileModel } from 'survey-core';
import { SurveyElementBase } from 'survey-react-ui';
import classNames from 'classnames';

import SurveyFilePreviewItemImage from './SurveyFilePreviewItem.svg?react';

import styles from '../SurveyFilePreview.module.scss';

export class SurveyFilePreviewItem extends SurveyElementBase<
  { question: QuestionFileModel; item: any },
  {}
> {
  protected get question(): QuestionFileModel {
    return this.props.question;
  }

  protected get item(): any {
    return this.props.item;
  }

  protected renderFileSign(className: string, val: any): JSX.Element | null {
    if (!className || !val.name) return null;
    return (
      <div className={classNames(className, styles.filesign)}>
        <a
          href={val.content}
          onClick={(event) => {
            this.question.doDownloadFile(event, val);
          }}
          title={val.name}
          download={val.name}
          style={{ width: this.question.imageWidth }}
        >
          {val.name}
        </a>
      </div>
    );
  }

  protected renderElement(): JSX.Element | null {
    const val = this.item;
    return (
      <span
        className={classNames(
          this.question.cssClasses.previewItem,
          styles.item
        )}
        onClick={(event) =>
          this.question.doDownloadFileFromContainer(event as any)
        }
      >
        {this.renderFileSign(this.question.cssClasses.fileSign, val)}
        <div className={this.question.getImageWrapperCss(val)}>
          {this.question.canPreviewImage(val) ? (
            <img
              src={val.content}
              style={{
                height: this.question.imageHeight,
                width: this.question.imageWidth,
              }}
              alt="File preview"
            />
          ) : this.question.cssClasses.defaultImage ? (
            <SurveyFilePreviewItemImage width={70} height={90} />
          ) : null}
          {val.name && !this.question.isReadOnly ? (
            <div
              className={this.question.getRemoveButtonCss()}
              onClick={(event) => this.question.doRemoveFile(val, event)}
            >
              <span className={this.question.cssClasses.removeFile}>
                {this.question.removeFileCaption}
              </span>
              {this.question.cssClasses.removeFileSvgIconId ? (
                <SurveyFilePreviewItemImage width={70} height={90} />
              ) : null}
            </div>
          ) : null}
        </div>
        {this.renderFileSign(this.question.cssClasses.fileSignBottom, val)}
      </span>
    );
  }
  protected canRender(): boolean {
    return this.question.showPreviewContainer;
  }
}
